module.exports = __webpack_public_path__ + "static/media/Landingpage.248ca269.jpg";